import Icon from '../components/Icon.vue'

Icon.register({
  vials: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M72 64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h208c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-24v240c0 44.1-35.9 80-80 80s-80-35.9-80-80v-240h-24zM144 64v96h64v-96h-64zM624 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h608zM360 64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h208c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-24v240c0 44.1-35.9 80-80 80s-80-35.9-80-80v-240h-24zM432 64v96h64v-96h-64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/vials.js
// module id = 2089
// module chunks = 0